// Reusable AJAX functionalities

 (function () {
  // called ajax request by passing any custom url
  RS.Utils.AjaxService = {
    // AjaxService object's method to make ajax request which accepts a url
    // and callback function timeout if not supplied sets to 10 sec
    processXHR: function (url, type, timeoutwait, successCallback, data, errorCallback, global) {
      return $.ajax({
        headers: {
          Accept: 'application/json',
          Authorization: 'Basic TW9iaWxlV2ViOmVtcHR5',
        },
        type: type,
        url: url,
        data: data,
        success: successCallback,
        timeout: (typeof timeoutwait !== 'undefined' ? timeoutwait : 10000),
        error: errorCallback,
        global: global !== undefined ? global : true,
      });
    },
    deferreds: [],
  };
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/utils/ajax.js
// module id = 318
// module chunks = 4